import protobuf from "protobufjs";
import deviceStats from "./deviceStats.json";

const root = protobuf.Root.fromJSON(deviceStats);
export default root;
